import { render } from "./PlanUsagePopover.vue?vue&type=template&id=aaf25f8e&scoped=true"
import script from "./PlanUsagePopover.vue?vue&type=script&lang=js"
export * from "./PlanUsagePopover.vue?vue&type=script&lang=js"

import "./PlanUsagePopover.vue?vue&type=style&index=0&id=aaf25f8e&scoped=true&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaf25f8e"]])

export default __exports__